import { handleActions } from 'redux-actions';
import actions from '../actions/planActions';
import { initialState } from '../initial-state';

export default handleActions(
    {
        [actions.UpdatePlanLuminaires]: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
    initialState.Plan

);
